(() => {
  const closeMenus = () => document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { const active = document.querySelector('.mobile-menu[open] summary'); closeMenus(); active?.focus(); } });
  document.addEventListener('click', event => {
    if (!event.target.closest('.mobile-menu') || event.target.closest('.mobile-menu a')) closeMenus();
  });
  const header = document.querySelector('.site-header');
  if (header) {
    const update = () => header.classList.toggle('is-scrolled', window.scrollY > 25);
    window.addEventListener('scroll', update, { passive: true }); update();
  }
})();
